module.exports = __webpack_public_path__ + "fonts/line-awesome.4d42f5f0.ttf";